// extracted by mini-css-extract-plugin
export default {"container":"document_form_input_container__02g+P","input":"document_form_input_input__N-P2K","tooltip":"document_form_input_tooltip__53EJs"};